import { render, staticRenderFns } from "./CampaignResume.vue?vue&type=template&id=6ff97ddb&scoped=true&"
import script from "./CampaignResume.vue?vue&type=script&lang=js&"
export * from "./CampaignResume.vue?vue&type=script&lang=js&"
import style0 from "./CampaignResume.vue?vue&type=style&index=0&id=6ff97ddb&scoped=true&lang=scss&"
import style1 from "./CampaignResume.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6ff97ddb",
  null
  
)

export default component.exports